import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { CellWrapper, CellDataDetail, CellDataDetailLabel } from './styles';
import IconFont from '../../shared/IconFont';
//eslint-disable-next-line
import { injectGlobal } from '../../ToolTip/styles';

export class TableCell extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isSorted: false,
    };
  }

  sortIcon = () => {
    if (this.props.isSortable) {
      this.setState({
        isSorted: !this.state.isSorted,
      });
      this.props.actions.sortColumn(this.props.colName, this.state.isSorted);
    }
  };

  render() {
    const {
      label, labelTooltip, width, children, weight, alignment, size, position,
      left, top, caps, isSortable, overrideMargin, overridePadding, isToolTip, specialTooltip, isMobile,
    } = this.props;
    const { isSorted } = this.state;
    return (
      <CellWrapper
        width={width}
        weight={weight}
        alignment={alignment}
        size={size}
        position={position}
        left={left}
        top={top}
        caps={caps}
        isSortable={isSortable}
        overrideMargin={overrideMargin}
        overridePadding={overridePadding}
        onClick={() => this.sortIcon()}
      >
        <CellDataDetail
          isSortable={isSortable}
          className={isToolTip ? specialTooltip ? 'tooltip_altered' : 'tooltip' : ''}
          alt={labelTooltip}
        >
          <CellDataDetailLabel isSortable={isSortable}>
            {label} {children}
          </CellDataDetailLabel>
          {isSortable && label && !isMobile &&
          <IconFont
            className={isSorted ? 'icon-matchcenter-up-arrow' : 'icon-matchcenter-down-arrow'}
            marginTop={0.2}
            withCursor
          />
        }
        </CellDataDetail>
      </CellWrapper>
    );
  }
}

TableCell.propTypes = {
  label: PropTypes.any,
  labelTooltip: PropTypes.any,
  width: PropTypes.any,
  children: PropTypes.any,
  weight: PropTypes.any,
  alignment: PropTypes.any,
  size: PropTypes.any,
  position: PropTypes.any,
  left: PropTypes.any,
  top: PropTypes.any,
  caps: PropTypes.any,
  isSortable: PropTypes.bool,
  overrideMargin: PropTypes.string,
  overridePadding: PropTypes.string,
  actions: PropTypes.any,
  colName: PropTypes.any,
  isToolTip: PropTypes.bool,
  isMobile: PropTypes.bool,
  specialTooltip: PropTypes.bool,
};

export default TableCell;



// WEBPACK FOOTER //
// ./src/components/DynamicTable/TableCell/index.js